module.exports = __webpack_public_path__ + "img/success-omni.ceca2d8d.png";